(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["apk-banner-form"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  function init() {
    var Sizes = window.GabylouSizes;
    var Filters = window.GabylouFilters;

    // popup.js est chargé dans le <head> par theme.liquid. S'il manque,
    // la section reste inerte plutôt que de lever une erreur.
    if (!Sizes || !Filters) {
      console.warn('[Gabylou] popup.js absent : la recherche par pointure est desactivee.');
      return;
    }

    var selectPointure = document.getElementById('search_taille');
    var selectMollet = document.getElementById('search_tailledemollet');
    if (!selectPointure || !selectMollet) return;

    var formulaire = selectPointure.closest('form');
    var champMollet = document.querySelector('.field.disabeld');
    var blocBouton = document.querySelector('.disable_button');

    // Aligne les value des options sur les libellés de filtre réels,
    // pour que la soumission native du formulaire fonctionne aussi.
    Filters.appliquerAuSelectPointure(selectPointure);

    function activer(element) {
      if (!element) return;
      element.style.opacity = '1';
      element.style.pointerEvents = 'auto';
    }

    /* Remplit le sélecteur de tour de mollet en fonction de la pointure.
       Les valeurs qu'aucune plage ne couvre sont proposées en grisé :
       aucun modèle n'y correspond, autant le montrer plutôt que de
       renvoyer une collection vide. */
    function majSelectMollet() {
      selectMollet.innerHTML = '';

      var placeholder = document.createElement('option');
      placeholder.text = (typeof placeholderMollet !== 'undefined' && placeholderMollet)
        ? placeholderMollet
        : 'Votre taille de mollet';
      placeholder.value = '';
      placeholder.disabled = true;
      placeholder.selected = true;
      selectMollet.appendChild(placeholder);

      var pointure = Sizes.pointureSelectionnee(selectPointure);
      Sizes.optionsMollet(pointure).forEach(function (entree) {
        var option = document.createElement('option');
        option.text = entree.valeur;
        option.value = entree.valeur;
        option.disabled = !entree.couverte;
        selectMollet.appendChild(option);
      });
    }

    selectPointure.addEventListener('change', function () {
      majSelectMollet();
      if (Sizes.pointureSelectionnee(selectPointure)) activer(champMollet);
    });

    selectMollet.addEventListener('change', function () {
      if (selectMollet.value) activer(blocBouton);
    });

    // Le bouton natif construit la même URL que le popup. Sans cela, le
    // formulaire n'envoyait que la pointure : le champ mollet n'a pas
    // d'attribut name et contient un tour de mollet en cm, pas une taille.
    if (formulaire) {
      formulaire.addEventListener('submit', function (evenement) {
        var pointure = Sizes.pointureSelectionnee(selectPointure);
        var taille = Sizes.tailleMollet(pointure, selectMollet.value);
        if (!pointure || !taille) return; // laisse le comportement par défaut
        evenement.preventDefault();
        Filters.rediriger(pointure, taille);
      });
    }

    majSelectMollet();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
